import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { AltriSoggettiComponent } from 'src/app/anagrafiche/altri-soggetti/altri-soggetti.component';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => RiparatorePickerComponent) },
  ],
  selector: 'riparatore-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class RiparatorePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(AltriSoggettiComponent, {
      data: {
        selectionMode: true,

        defaultSearch: {
          tipo: new TipoAltroSoggetto().deserialize({
            nome: 'Riparatore',
            id: 4,
          })
        }
      }
    }).afterClosed();
  };


}
